<template></template>

<script>
import Callout from './Callout'
import cSwitch from './Switch'
export default {
	name: 'c-aside',
	components: {
		Callout,
		cSwitch,
	},
}
</script>
